import { FormDefinition } from "../../Components/Form/Form";
import { address_validator, basic_text_validator, description_validator, firm_name_validator, unique_email_validator, url_validator } from "../formFieldValidators";

export const newServiceProviderFirmFormDefinition: FormDefinition = {
  name: {
    label: "Name",
    frLabel: "Nom",
    inputType: "text",
    validator: firm_name_validator,
    placeholder: "Service provider name"
  },
  address: {
    label: "Enter Firm Location",
    frLabel: "Saisir l’emplacement de la firme",
    inputType: "address",
    validator: address_validator,
    placeholder: "Start typing address..."
  },
  contact: {
    label: "Contact Person",
    frLabel: "Personne ressource de l’entreprise pour communications ÉPI",
    inputType: "text",
    placeholder: "Contact person name",
    validator: basic_text_validator,
  },
  contactEmail: {
    label: "Email address",
    frLabel: "Courriel de la personne ressource",
    inputType: "text",
    validator: basic_text_validator,
    placeholder: "Email address"
  },
  region: {
    label: "Select Region",
    frLabel: "Sélectionner la région",
    inputType: "dropdownSelect",
    validator: {
      required: {
        value: true,
        message: "Please select an option"
      }
    },
    additionalData: {
      selectionData: [
        {
          value: "communitech", 
          text: "Communitech"
        },
        {
          value: "northForge", 
          text: "North Forge"
        },
        {
          value: "investOttawa", 
          text: "Invest Ottawa"
        }
      ]
    }
  },
  description: {
    label: "Description",
    placeholder: "Describe your firm's services and expertise",
    frLabel: "Description",
    inputType: "textarea",
    validator: description_validator,
  },
  industriesOfFocus: {
    label: "Industries of Focus",
    placeholder: "e.g., SaaS, Hardware, Biotech",
    frLabel: "Industries ciblées",
    inputType: "textarea",
    validator: basic_text_validator,
  },
  websiteURL: {
    label: "Website",
    placeholder: "URL",
    frLabel: "URL du site Web",
    inputType: "text",
    validator: url_validator,
  },
  languages: {
    label: "Languages Offered",
    frLabel: "Langues offertes",
    inputType: "text",
    placeholder: "e.g., English, French",
    validator: basic_text_validator,
  },
  hstNumber: {
    label: "HST/GST Number",
    frLabel: "Numéro de TPS/TVH",
    inputType: "text",
    validator: { ...basic_text_validator, required: false },
    placeholder: "e.g., 123456789RT0001",
    tooltip: { content: "15-character CRA GST/HST account number: 9-digit Business Number + RT + 4-digit reference (e.g., 123456789RT0001).", position: "top-left" },
  },
}


export const createExpertProfileFormDefinition: FormDefinition = {
  firstName: {
    label: "First Name",
    frLabel: "Prénom",
    inputType: "text",
    validator: basic_text_validator,
  },
  lastName: {
    label: "Last Name",
    frLabel: "Nom de famille",
    inputType: "text",
    validator: basic_text_validator,
  },
  uniqueEmail: {
    label: "Email",
    frLabel: "Courrier",
    inputType: "text",
    validator: unique_email_validator,
  },
  userRegion: { 
    label: "Select Service Provider Region",
    frLabel: "Sélectionner Organisation/Admin",
    inputType: "dropdownSelect",
    validator: {
      required: {
        value: true,
        message: "Please select an option"
      }
    },
    additionalData: {
      selectionData: [
        {
          value: "communitech", 
          text: "Communitech"
        },
        {
          value: "northForge", 
          text: "North Forge"
        },
        {
          value: "investOttawa", 
          text: "Invest Ottawa"
        }
      ]
    }
  },
  calendly: {
    label: "Meeting Scheduling Link",
    placeholder: "https://calendly.com/your-name/meeting",
    inputType: "text",
    validator: url_validator,
  },
}


export const createServiceProviderProfileFormDefinition: FormDefinition = {
  firstName: {
    label: "First Name",
    frLabel: "Prénom",
    inputType: "text",
    validator: basic_text_validator,
  },
  lastName: {
    label: "Last Name",
    frLabel: "Nom de famille",
    inputType: "text",
    validator: basic_text_validator,
  },
  uniqueEmail: {
    label: "Email",
    frLabel: "Courrier",
    inputType: "text",
    validator: unique_email_validator,
  },
  firm: {
    label: "Select Service Provider Firm",
    frLabel: "Sélectionner Organisation/Admin",
    inputType: "dropdownSelect",
    validator: {
      required: {
        value: true,
        message: "Please select an option"
      }
    },
    additionalData: {
      selectionData: [
        {
          value: "firm1", 
          text: "Firm 1"
        },
        {
          value: "firm2", 
          text: "Firm 2"
        },
        {
          value: "firm3", 
          text: "Firm 3"
        }
      ]
    }
  },
  userRegion: { 
    label: "Select Service Provider Region",
    frLabel: "Sélectionner Organisation/Admin",
    inputType: "dropdownSelect",
    validator: {
      required: {
        value: true,
        message: "Please select an option"
      }
    },
    additionalData: {
      selectionData: [
        {
          value: "communitech", 
          text: "Communitech"
        },
        {
          value: "northForge", 
          text: "North Forge"
        },
        {
          value: "investOttawa", 
          text: "Invest Ottawa"
        }
      ]
    }
  },
}

